export default __webpack_public_path__ + "static/media/a023-startup2-en.289ac93d.png";